<template>
  <div class="cp_alert fadeIn animated" @touchmove.prevent>
    <div class="mask" @touchmove="_stopDef">
      <div class="content" :class="{'msg': type != 'alert'}">
        <!-- <div class="alert" v-if="type == 'alert'">!</div> -->
        {{msg || '提交失败，请重新上传身份证正反 面照片!'}}
        <div class="confirm" @click="submit"></div>
        <div class="close" @click="esc"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      show: this.propsShow
    };
  },
  mounted: function () {
  },
  methods: {
    submit() {
      this.$emit('close');
    },
    esc () {
      this.$emit('close');
    },
    _stopDef(e) {
      e.preventDefault();
    }
  },
  watch: {

  },
  props: {
    'msg': {
      type: String,
      default: ''
    },
    'type': {
      type: String,
      default: 'alert'
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus">
.cp_alert
  width: 100%;
  height: 100%;
  position absolute
  z-index 10
  top 0
  animation-duration 0.4s !important
  .mask {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: 200;
    position: fixed;
    top:0;
    left:0;
  }
  .content
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 300;
    width 7.5rem;
    height 4.87rem
    background-image url('./bg.png')
    background-size 100% 100%
    font-size 0.3rem;
    line-height 0.5rem;
    color: #5b4538
    text-align center
    padding: 2rem 1.34rem 0;
    z-index: 10;
    &.msg
      color: #5b4538
    .alert
        width 0.76rem
        height 0.76rem
        border-radius 50%
        text-align center
        line-height 0.76rem
        font-size 0.48rem
        font-weight bold
        background-color #b72222
        color #5b4538
        margin-left 1.87rem
        margin-bottom 0.3rem;
  .close
    position absolute
    width 0.73rem;
    height 0.73rem;
    background-image url('../images/close.png')
    background-size 100% 100%
    top -0.44rem;
    right 0.21rem;
  .confirm
    width 2.55rem;
    height 0.77rem;
    position absolute
    bottom 0.5rem;
    left: 50%;
    margin-left: -1.275rem;
    background-image url('./confirm.png')
    background-size 100% 100%
    font-size: 0.36rem;
    line-height: 0.83rem;
    text-align: center
    color: #1a191f
    font-weight: bold
</style>
